var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list"},[_c('ul',_vm._l((_vm.projects),function(project){return _c('li',[(project.hidden!==1)?_c('router-link',{attrs:{"to":project.slug}},[_c('span',{staticClass:"space"},[_vm._v("–")]),_vm._v(_vm._s(project.title)+"\n      ")]):_vm._e()],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772805a4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/List.vue
// module id = 29
// module chunks = 0